import kernel from "./inversify.standalone.config";
import {init} from "@/init";

init(kernel);
